import { useState } from "react";
import {
  ModalRetorno,
  useModalRetorno,
} from "../../../SolicitacaoPlaca/components/ModalRetorno";
import { useLotesTerceiros } from "../../hooks/useLotesTerceiros";
import { useRecarregarAoAtivar } from "../../hooks/useRecarregarAoAtivar";
import { ILoteTerceiros } from "../../interfaces/ILoteTerceiros";
import { RemoverLoteModal } from "../../modals/RemoverLoteModal";
import { FiltrosLotes } from "../FiltrosLotes";
import { ListarLotes } from "../ListarLotes";

interface IProps {
  ativa: boolean;
  onLoteRemovido: () => void;
}

export function LotesGerados({ ativa, onLoteRemovido }: IProps) {
  const {
    lotes,
    totalRegistros,
    carregando,
    limite,
    reiniciarPaginacao,
    aplicarFiltros,
    setPagina,
    mudarLimite,
    ordenar,
    recarregar,
    exportar,
    exportando,
    remover,
    removendo,
    baixar,
    baixando,
  } = useLotesTerceiros();
  const [loteParaRemover, setLoteParaRemover] = useState<ILoteTerceiros | null>(
    null
  );
  const { mostrarRetorno, propsModalRetorno } = useModalRetorno();

  useRecarregarAoAtivar(ativa, recarregar);

  async function confirmarRemocao() {
    if (!loteParaRemover) return;

    const resultado = await remover(loteParaRemover.id);

    if (resultado === "falha") return;

    setLoteParaRemover(null);
    onLoteRemovido();
    if (resultado === "removido") {
      mostrarRetorno("Remover lote", "Lote removido com sucesso!");
    }
  }

  return (
    <>
      <ModalRetorno {...propsModalRetorno} />
      <FiltrosLotes onBuscar={aplicarFiltros} />
      <ListarLotes
        lotes={lotes}
        totalRegistros={totalRegistros}
        carregando={carregando}
        limite={limite}
        reiniciarPaginacao={reiniciarPaginacao}
        onMudarPagina={setPagina}
        onMudarLimite={mudarLimite}
        onOrdenar={ordenar}
        onExportar={exportar}
        exportando={exportando}
        baixando={baixando}
        onBaixar={baixar}
        onRemover={setLoteParaRemover}
      />
      <RemoverLoteModal
        show={loteParaRemover !== null}
        carregando={removendo}
        onCancelar={() => setLoteParaRemover(null)}
        onConfirmar={confirmarRemocao}
      />
    </>
  );
}
